import PassportBadge from './PassportBadge'

export default PassportBadge
